import { GameApp } from './app';

const gameApp = new GameApp();

console.log("success");